import React from "react"
import { FloatingInput } from "../../components/utils/FloatingInput";

/**
 * Dynamically composes/renders form input elements based on the attributes.
 * It determines the appropriate input type (`glyph`, `epoch`, `arbiter`) and applies relevant properties.
 * 
 * ## Key Functionalities:
 * - Handles Dynamic Input Rendering: Maps attributes to input components.
 * - Decodes and Parses Properties: Extracts additional metadata.
 * - Retrieves Input Values & Errors: Uses `retrieveFacetXID` to fetch stored values and validation errors.
 * - Handles Input State Updates: Connects fields to `changeHandler` and `blurHandler`.
 * 
 * @param {Object} axt - The attribute definition for rendering the input block.
 * @param {string} oid - The identifier associated with the input field.
 * @param {Object[]} datum - The preview dataset containing field metadata.
 * @param {Object[]} input - The input state containing user-entered values.
 * @param {Object[]} faults - The validation state containing field errors.
 * @param {boolean} posting - Indicates whether a submission is in progress, disabling inputs if `true`.
 * @param {Function} changeHandler - The event handler for tracking input value changes.
 * @param {Function} blurHandler - The event handler for handling validation on input blur.
 * @param {Function} optionHandler - The event handler for checkbox and radio button inputs.
 * 
 * @returns {JSX.Element} - The dynamically rendered input field or block.
 */
export const FormComposer = ({ element, values, faults, phase, state, changeHandler, blurHandler, optionHandler, dateHandler }: any): JSX.Element => {

    const labelSubtitle = (
        <div className="w-full">
            <div className="w-full flex text-sm flex-row items-center align-middle gap-x-2 pb-1">
                <h3 className="flex-grow dark:text-slate-300">
                    {element.e}:
                    {element.m ? <sup className="text-red-600 text-xs pl-1">*</sup> : null}
                </h3>
            </div>

            {
                element.t && (
                    <div className="text-xs flex-grow text-slate-500 dark:text-slate-400 mb-3">
                        <span className="block text-xs">{element.t}</span>
                    </div>
                )
            }
        </div>
    );    

    return (
        <React.Fragment>
            {(() => {
                switch (element.f?.format) {
                    case 'freetext':
                        return (
                            <FloatingInput
                                name={element.g}
                                label={element.e}
                                required={element.m}
                                posting={state.posting}
                                value={values[element.g]}
                                error={faults[element.g]}
                                blurHandler={(e: any) => blurHandler(e, phase, element)}
                                changeHandler={changeHandler}
                            />
                        )
                }

                return (
                    <>

                    </>
                )
            })()}
        </React.Fragment>
    )
}